import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

export default function withTracker(WrappedComponent, options = {}) {
    return function TrackedComponent(props) {
        const location = useLocation();

        useEffect(() => {
            const page = location.pathname + (location.search || '');
            ReactGA.set({ page, ...options });
            ReactGA.pageview(page);
        }, [location.pathname, location.search]);

        return <WrappedComponent {...props} />;
    };
}
